// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://pbtpa.aclarian.com',
  appName: 'Palm Beach Transportation Planning Agency  | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub74cabb4d1be61c3851453c3e65384cc0',
  datadogApplicationId: 'af639b65-b3bb-4bb5-aa80-d10b2f38177a',
  datadogService: 'invoicing_pbtpa_prod',
  ApiKey: 'Yk3@ZQP%wN87Gt#M',
  env: 'PROD',
  version: packageInfo.version,
};
